import { BaseEntity } from 'yt-ng-framework';
//import { THROW_IF_NOT_FOUND } from '@angular/core/src/di/injector';
export class KarticaMpArtikla extends BaseEntity {
    constructor() {
        super();
    }

    // Vd: String = null;
    BrDok: String = null;
    Datum: Date = null;
    KomitentNaziv: String = null;
    Ulaz: Number = null;
    Izlaz: Number = null;
    Stanje: Number = null;
    CenaDob: Number = null;
    CenaNab: Number = null;
    CenaProd: Number = null;
    CenaPreNivel: Number = null;
    PdvJm: Number = null;
    PoslednjiUlaz: Boolean = null;
    SumarniSlog: Boolean = null;
    T01StanjeArtiklaZaPeriod: Number = null;
    T02ProdajnaCenaArtiklaNaKrajuPeriod: Number = null;
    T03ProdajnaCenaBezPdvArtiklaNaKrajuPerioda: Number = null;
    T04VrednostLageraArtiklaNaKrajuPerioda: Number = null;
    T05VrednostLageraBezPdvArtiklaNaKrajuPerioda: Number = null;
    T06VrednostUlazaArtiklaPoNabavnojCeni: Number = null;
    T07VrednostIzlazaArtiklaPoProsecnojNabavnojCeni: Number = null;
    T08VrednostIzlazaArtiklaPoProdajnojCeni: Number = null;
    T09UkupnoPdvIzlazRobe: Number = null;
    T10VrednostIzlazaArtiklaPoProdajnojCeniBezPdv: Number = null;
    T11RealizacijaDoUlozenogNovca: Number = null;
    T12UkupnoOstvarenaRazlikaUCeniNaKrajuPerioda: Number = null;

    Deserialize(input: any) {
        // this.Vd=input.Vd;
        this.BrDok = input.BrDok;
        this.Datum = input.Datum;
        this.KomitentNaziv = input.KomitentNaziv;
        this.Ulaz = input.Ulaz;
        this.Izlaz = input.Izlaz;
        this.Stanje = input.Stanje;
        this.CenaDob = input.CenaDob;
        this.CenaNab = input.CenaNab;
        this.CenaProd = input.CenaProd;
        this.CenaPreNivel = input.CenaPreNivel;
        this.PdvJm = input.PdvJm;
        this.PoslednjiUlaz = input.PoslednjiUlaz;
        this.SumarniSlog = input.SumarniSlog;
        this.T01StanjeArtiklaZaPeriod = input.T01StanjeArtiklaZaPeriod;
        this.T02ProdajnaCenaArtiklaNaKrajuPeriod = input.T02ProdajnaCenaArtiklaNaKrajuPeriod;
        this.T03ProdajnaCenaBezPdvArtiklaNaKrajuPerioda = input.T03ProdajnaCenaBezPdvArtiklaNaKrajuPerioda;
        this.T04VrednostLageraArtiklaNaKrajuPerioda = input.T04VrednostLageraArtiklaNaKrajuPerioda;
        this.T05VrednostLageraBezPdvArtiklaNaKrajuPerioda = input.T05VrednostLageraBezPdvArtiklaNaKrajuPerioda;
        this.T06VrednostUlazaArtiklaPoNabavnojCeni = input.T06VrednostUlazaArtiklaPoNabavnojCeni;
        this.T07VrednostIzlazaArtiklaPoProsecnojNabavnojCeni = input.T07VrednostIzlazaArtiklaPoProsecnojNabavnojCeni;
        this.T08VrednostIzlazaArtiklaPoProdajnojCeni = input.T08VrednostIzlazaArtiklaPoProdajnojCeni;
        this.T09UkupnoPdvIzlazRobe = input.T09UkupnoPdvIzlazRobe;
        this.T10VrednostIzlazaArtiklaPoProdajnojCeniBezPdv = input.T10VrednostIzlazaArtiklaPoProdajnojCeniBezPdv;
        this.T11RealizacijaDoUlozenogNovca = input.T11RealizacijaDoUlozenogNovca;
        this.T12UkupnoOstvarenaRazlikaUCeniNaKrajuPerioda = input.T12UkupnoOstvarenaRazlikaUCeniNaKrajuPerioda;

        return this;
    }

    Serialize(input: KarticaMpArtikla) {
        return input;
    }

    blankIfZero(value) {
        return value == 0 ? "" : value;
    }

}   